// parameters that have been registered as 'Custom Dimension' on Google Analytics
export const GTAG_REGISTERED_PARAMS = {
  type: 'type',
  source: 'source',
  doctorId: 'doctorId',
  profileCount: 'profileCount',
  result: 'result',
};

// Valid values for the `type` param — describes which feature/flow the event belongs to.
export const GTAG_PARAMS_TYPE = {
  InviteLink: 'invite-link',
  InviteCode: 'invite-code',
  QrCodeClaimProfile: 'qr-code-claim-profile',
  BabybookPreview: 'babybook-preview',
};

// Valid values for the `source` param — identifies which screen / surface fired the event.
export const GTAG_PARAMS_ORIGIN = {
  NswebDashboard: 'nsweb-dashboard',
  ClaimRecordsModal: 'claim-records-modal',
  ClaimRecordsModal_List: 'claim-records-modal--list',
  ClaimRecordsModal_VerifyForm: 'claim-records-modal--verify_form',
  ClaimRecordsModal_NoMatch: 'claim-records-modal--no_match',
  ClaimRecordsModal_InvalidToken: 'claim-records-modal--invalid_token',
  ClaimRecordsModal_Confirmed: 'claim-records-modal--confirmed',
  ClaimRecordsModal_AutoClaim: 'claim-records-modal--auto_claim',
  BabybookPreview_AppStore: 'babybook-preview--appstore',
  BabybookPreview_PlayStore: 'babybook-preview--playstore',
  BabybookPreview_Web: 'babybook-preview--web',
};

// Valid values for the `result` param.
export const GTAG_PARAMS_RESULT = {
  Success: 'success',
  Fail: 'fail',
  RateLimited: 'rate_limited',
};
